document.documentElement.classList.add("js-enabled");
class PlayroomNavigation {
  constructor(root) {
    this.root = root;
    this.trigger = root.querySelector("summary");
    this.panel = root.querySelector(".menu-panel");
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    root.addEventListener("toggle", () => this.sync(), options);
    root
      .querySelector("[data-menu-close]")
      .addEventListener("click", () => this.close(), options);
    root.addEventListener(
      "keydown",
      (event) => {
        if (!root.open) return;
        if (event.key === "Escape") {
          event.preventDefault();
          event.stopPropagation();
          const branch = event.target.closest(".nav-branch[open]");
          if (branch) {
            branch.open = false;
            branch.querySelector("summary").focus();
          } else this.close();
        }
        if (event.key === "Tab") {
          const targets = [
            ...this.panel.querySelectorAll(
              "a, button, input:not([type=hidden]), summary",
            ),
          ].filter((el) => el.getClientRects().length);
          const first = targets[0],
            last = targets.at(-1);
          if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
          } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
          }
        }
      },
      options,
    );
    root.addEventListener(
      "click",
      (event) => {
        if (event.target.closest("a")) this.close(false);
      },
      options,
    );
    this.media = matchMedia("(min-width: 1100px)");
    this.media.addEventListener(
      "change",
      () => {
        if (this.media.matches) this.close(false);
      },
      options,
    );
  }
  sync() {
    const open = this.root.open;
    document.body.classList.toggle("menu-open", open);
    const main = document.querySelector("main");
    const footer = document.querySelector("footer");
    for (const el of [
      main,
      footer,
      ...document.querySelectorAll(".logo-link,.header-tools"),
    ]) {
      if (el) el.inert = open;
    }
    if (open) {
      this.panel.setAttribute("role", "dialog");
      this.panel.setAttribute("aria-modal", "true");
      this.panel.setAttribute(
        "aria-label",
        this.panel.querySelector(".menu-top span").textContent.trim(),
      );
      this.panel.querySelector("[data-menu-close]").focus({ preventScroll: true });
      if (!matchMedia("(prefers-reduced-motion: reduce)").matches)
        this.panel.animate(
          [
            { opacity: 0.9, transform: "translateY(-8px)" },
            { opacity: 1, transform: "translateY(0)" },
          ],
          { duration: 180, easing: "ease-out" },
        );
    } else {
      this.panel.removeAttribute("role");
      this.panel.removeAttribute("aria-modal");
    }
  }
  close(restore = true) {
    this.root.open = false;
    this.sync();
    if (restore) this.trigger.focus({ preventScroll: true });
  }
  destroy() {
    this.close(false);
    this.controller.abort();
  }
}
const menus = new Map();
function mount(scope = document) {
  scope.querySelectorAll("[data-menu]").forEach((root) => {
    if (!menus.has(root)) menus.set(root, new PlayroomNavigation(root));
  });
}
mount();
document.addEventListener("shopify:section:load", (event) =>
  mount(event.target),
);
document.addEventListener("shopify:section:unload", (event) => {
  for (const [root, instance] of menus)
    if (event.target.contains(root)) {
      instance.destroy();
      menus.delete(root);
    }
});
document.addEventListener("keydown", (event) => {
  if (event.key === "Escape")
    document
      .querySelectorAll(".desktop-nav .nav-branch[open]")
      .forEach((root) => {
        root.open = false;
        root.querySelector("summary").focus();
      });
});
